import { useState } from "react";
import { User, MapPin, ChevronDown } from "lucide-react";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";

/**
 * Vorbesitzer-Block (Phase 4.20 — ehem. ZB1 Extended).
 *
 * Feb-2026 (User-Wunsch 22 May): Heading auf "Vorbesitzer" gekürzt, alle
 * Adress-Felder in einer kompakten 6-Spalten-Zeile (Vorname, Name/Firma,
 * Straße, Hausnr., PLZ, Stadt).
 */
const ZB1_KEYS = [
    "previous_owner_first_name", "previous_owner_last_name_or_company",
    "previous_owner_street", "previous_owner_house_number",
    "previous_owner_postal_code", "previous_owner_city",
];

export default function Zb1ExtendedFieldsSection({ form, update }) {
    const filledCount = ZB1_KEYS.reduce((acc, k) => acc + (form[k] != null && form[k] !== "" ? 1 : 0), 0);
    // Feb-2026 (User-Wunsch) — IMMER zugeklappt starten (auch wenn Daten vorhanden);
    // der Zähler signalisiert, dass bereits Vorbesitzer-Daten erfasst sind.
    const [open, setOpen] = useState(false);

    return (
        <div className="bg-white border border-gray-200 rounded-sm" data-testid="zb1-extended-section">
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                className="w-full flex items-center gap-3 p-4 text-left hover:bg-gray-50 transition-colors"
                aria-expanded={open}
                data-testid="zb1-extended-toggle"
            >
                <User className="w-4 h-4 text-gray-500 shrink-0" />
                <div className="flex-1 min-w-0">
                    <h3 className="font-display font-bold text-base">Vorbesitzer</h3>
                    {open && (
                        <p className="text-xs text-gray-600 mt-0.5">
                            Daten aus C.1.1 – C.1.3 (Name / Anschrift).
                        </p>
                    )}
                </div>
                {filledCount > 0 && (
                    <span className="shrink-0 text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 bg-[#FFCC00]/30 text-[#111827] rounded-sm font-mono-num" data-testid="zb1-extended-count">
                        {filledCount}
                    </span>
                )}
                <ChevronDown
                    className={`w-5 h-5 text-gray-500 transition-transform shrink-0 ${open ? "rotate-180" : ""}`}
                />
            </button>

            {open && (
                <div className="px-5 pb-5" data-testid="zb1-extended-content">
                    <div className="grid grid-cols-2 lg:grid-cols-3 gap-2" data-testid="zb1-prev-owner-block">
                        <div>
                            <Label className="text-[10px] uppercase tracking-wider font-bold text-gray-500">Vorname</Label>
                            <Input value={form.previous_owner_first_name ?? ""} onChange={(e) => update("previous_owner_first_name", e.target.value)} className="rounded-sm h-8 text-sm" data-testid="form-prev-owner-first" />
                        </div>
                        <div>
                            <Label className="text-[10px] uppercase tracking-wider font-bold text-gray-500">Name / Firma</Label>
                            <Input value={form.previous_owner_last_name_or_company ?? ""} onChange={(e) => update("previous_owner_last_name_or_company", e.target.value)} className="rounded-sm h-8 text-sm" data-testid="form-prev-owner-last" />
                        </div>
                        <div>
                            <Label className="text-[10px] uppercase tracking-wider font-bold text-gray-500 flex items-center gap-1"><MapPin className="w-3 h-3" />Straße</Label>
                            <Input value={form.previous_owner_street ?? ""} onChange={(e) => update("previous_owner_street", e.target.value)} className="rounded-sm h-8 text-sm" data-testid="form-prev-owner-street" />
                        </div>
                        <div>
                            <Label className="text-[10px] uppercase tracking-wider font-bold text-gray-500">Nr.</Label>
                            <Input value={form.previous_owner_house_number ?? ""} onChange={(e) => update("previous_owner_house_number", e.target.value)} className="rounded-sm h-8 text-sm font-mono-num" data-testid="form-prev-owner-house" />
                        </div>
                        <div>
                            <Label className="text-[10px] uppercase tracking-wider font-bold text-gray-500">PLZ</Label>
                            <Input value={form.previous_owner_postal_code ?? ""} maxLength={5} onChange={(e) => update("previous_owner_postal_code", e.target.value.replace(/\D/g, "").slice(0, 5))} className="rounded-sm h-8 text-sm font-mono-num" data-testid="form-prev-owner-plz" />
                        </div>
                        <div>
                            <Label className="text-[10px] uppercase tracking-wider font-bold text-gray-500">Stadt</Label>
                            <Input value={form.previous_owner_city ?? ""} onChange={(e) => update("previous_owner_city", e.target.value)} className="rounded-sm h-8 text-sm" data-testid="form-prev-owner-city" />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
